module.exports = __webpack_public_path__ + "3f81e681683b3bb68601a3cfab4d9e88.png";